import BaseComponent from 'scripts/BaseComponent.js';

export default class ProductDeliveryChecker extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      input: '.js-zipcodeSearchInput',
      status: '.js-status',
      productSubmitBtn: '.js-productSubmitBtn',
    };

    this.dom = {
      $component: component,
      $input: this.$get(this.refs.input),
      $status: this.$get(this.refs.status),
      $productSubmitBtn: document.querySelector(this.refs.productSubmitBtn),
    };

    this.state = {
      zipcodeCheckerType: null,
      zipcodeSelectedEvent: 'zipcodeselected',
      focusZipcodeCheckerEvent: 'focuszipcodechecker',
      emptySearchEvent: 'emptysearch',
      deliveryDisabledClass: 'delivery-disabled',
    };

    this.mount();
  }

  mount() {
    const { dom, state } = this;
    super.mount();

    const { checkerType } = dom.$component.dataset;
    state.zipcodeCheckerType = checkerType;

    this.setOnCustomEvent(state.zipcodeSelectedEvent, this.handleZipCodeSelect);
    this.setOnCustomEvent(state.focusZipcodeCheckerEvent, this.focusZipcodeChecker);
    this.setOnCustomEvent(state.emptySearchEvent, this.handleSearchStatus);
  }

  handleZipCodeSelect({ detail }) {
    const { dom } = this;
    const { coast } = detail;
    const { targetCoast } = dom.$component.dataset;

    this.handleSearchStatus(coast === targetCoast);
  }

  handleSearchStatus(event) {
    const { dom, state } = this;
    const searchSuccess = event && !event.target;

    if (searchSuccess) {
      dom.$status.classList.remove('error');
      dom.$status.classList.add('success');
      dom.$productSubmitBtn.classList.remove(state.deliveryDisabledClass);
    } else {
      dom.$status.classList.remove('success');
      dom.$status.classList.add('error');
      if (state.zipcodeCheckerType !== 'Enable checker') {
        dom.$productSubmitBtn.classList.add(state.deliveryDisabledClass);
      }
    }
  }

  focusZipcodeChecker() {
    const { dom } = this;
    dom.$input.focus();
  }
}
